<template>
  <WorkBasicIconDialog
    v-bind="$props"
    ref="dialog"
    color="primary"
    icon-code="$wHelp"
  >
    <template #header>
      <slot name="header">
        {{ $t('Dialogs.QuestionDialog.title') }}
      </slot>
    </template>

    <template #content-append>
      <slot name="content-append" />
    </template>

    <template #dialog-actions="{ triggerResolve, triggerReject, close }">
      <slot
        name="dialog-actions"
        :trigger-resolve="triggerResolve"
        :trigger-reject="triggerReject"
        :close="close"
      >
        <template #abort-action>
          <slot
            name="abort-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
          >
            <template #abort-action-text>
              <slot name="abort-action-text" />
            </template>

            <!-- why not triggerReject? -->
            <WorkButton @click="triggerResolve(false)">
              {{ $t('Dialogs.QuestionDialog.abort') }}
            </WorkButton>
          </slot>
        </template>

        <template #accept-action>
          <slot
            name="accept-action"
            :trigger-resolve="triggerResolve"
            :trigger-reject="triggerReject"
            :close="close"
          >
            <template #accept-action-text>
              <slot name="accept-action-text" />
            </template>

            <WorkButton @click="triggerResolve(true)">
              {{ $t('Dialogs.BasicDialog.accept') }}
            </WorkButton>
          </slot>
        </template>
      </slot>
    </template>
  </WorkBasicIconDialog>
</template>

<script>
// components
import WorkBasicIconDialog from "./WorkBasicIconDialog";
import WorkButton from "@/components/global_components/buttons/WorkButton";
// services & helpers
import i18n from "@/language/i18n";
import WORK_DIALOG_SIZES from '@/components/base_components/dialog/components/enums/WORK_DIALOG_SIZES';
import { ref } from 'vue';


export default {
  name: "WorkQuestionDialog",
  components: { 
    WorkBasicIconDialog,
    WorkButton
  },
  props: {
    iconLabel: { type: String, default: i18n.t('Dialogs.QuestionDialog.title') },
    message: { type: String, default: i18n.t('Dialogs.QuestionDialog.message') },
    width: { type: String, default: WORK_DIALOG_SIZES.MEDIUM },
    height: { type: String },
    description: { type: String },
    noSimpleClose: { type: Boolean },
    hasHtml: { type: Boolean, default: false }
  },
  setup() {
    const dialog = ref(null);

    function open() {
      return dialog.value.open();
    }
    
    return { open, dialog }
  }
}
</script>
